import { BackendModel, BackendService } from '../core/backend.service';

export class SubclienteMontoMasivo {
    public static path = '/subclientes/';

    idClientePadre: number;
    montoMaximoMasivo: number;
    idTipoMontoMaximoMasivo: number;

    constructor() {
      
    }

}


// WEBPACK FOOTER //
// ./src/app/cliente/subclienteMontoMasivo.model.ts